import {
  appendDicomStoreFromConfig,
  finalizeShareableQueryString,
  appendDicomStoreTildeToExistingQuery,
  getDicomStorePathFromSearch,
} from './dicomStoreUrl';

const DICOM_STORE_PRESERVE_KEYS = [
  'dicomStore',
  'dicomStorePath',
  'gcpDicomStorePath',
  'dicomwebRoot',
  'dicomWebRoot',
];

function preserve(query, current, key) {
  const value = current.get(key);
  if (value) {
    query.append(key, value);
  }
}

export const preserveKeys = [
  'configUrl',
  'multimonitor',
  'screenNumber',
  'hangingProtocolId',
  // DICOM store selection via URL (shareable links)
  ...DICOM_STORE_PRESERVE_KEYS,
];

export function preserveQueryParameters(
  query,
  current = new URLSearchParams(window.location.search),
  dataSourceConfig = null
) {
  for (const key of preserveKeys) {
    if (DICOM_STORE_PRESERVE_KEYS.includes(key)) {
      continue;
    }
    preserve(query, current, key);
  }

  const currentSearch = typeof window !== 'undefined' ? window.location.search : '';
  if (!getDicomStorePathFromSearch(currentSearch, current)) {
    appendDicomStoreFromConfig(query, dataSourceConfig);
  }
}

export function preserveQueryStrings(query, current = new URLSearchParams(window.location.search)) {
  for (const key of preserveKeys) {
    if (DICOM_STORE_PRESERVE_KEYS.includes(key)) {
      continue;
    }
    const value = current.get(key);
    if (value) {
      query[key] = value;
    }
  }
}

export { finalizeShareableQueryString, appendDicomStoreTildeToExistingQuery };
